import * as http from './http';

// 获取验证码接口
export const loginSendCode = (params) => http.post(`/sms/send`, params);
export const loginApi = (params) => http.post(`/user/login`, params,{interceptRes: false});
